import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import RatingComponent from "@/pages/price-offer/components/RatingComponent";
import { useTranslation } from "@i18n";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import { Icon } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
import useHelpers from "@hooks/useHelpers";
import { useLang } from "@/common/Contexts/LanguageContext";
var PriceOfferInspectionSuccessPage = function PriceOfferInspectionSuccessPage() {
  var _state$offerData;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _usePriceOfferContext = usePriceOfferContext(),
    state = _usePriceOfferContext.state,
    scheduleData = _usePriceOfferContext.scheduleData,
    helpers = _usePriceOfferContext.helpers,
    selectedArea = _usePriceOfferContext.selectedArea,
    selectedCity = _usePriceOfferContext.selectedCity;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var lang = useLang();
  var renderAreaName = function renderAreaName() {
    var areaName = lang === "ar" ? selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.name_ar : selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.name;
    if (areaName == undefined || areaName === "") {
      return selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.name_ar;
    }
    return (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.name_ar) + ", " + areaName;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:max-w-[360px] md:mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/success.svg",
    alt: "Success",
    height: "82",
    width: "96"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary font-bold text-2xl text-center"
  }, tShort("price_offer/success_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] font-regular text-base text-center"
  }, tShort("price_offer/success_description", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-solid border-gray-gainsboro rounded-t px-3 py-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-sm font-bold"
  }, state === null || state === void 0 ? void 0 : (_state$offerData = state.offerData) === null || _state$offerData === void 0 ? void 0 : _state$offerData.title)), /*#__PURE__*/React.createElement("div", {
    className: "border-b border-e border-s border-solid border-gray-gainsboro px-3 py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--today-outline",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-xs font-bold"
  }, tShort("price_offer/success_inspection_date_title", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text text-sm font-semibold"
  }, helpers.getSelectedTimeStampWithDayPrefix()))), /*#__PURE__*/React.createElement("div", {
    className: "border-b border-e border-s border-solid border-gray-gainsboro px-3 py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--schedule-outline-rounded",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-xs font-bold"
  }, tShort("price_offer/success_inspection_time_title", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text text-sm font-semibold"
  }, helpers.getSelectedTimeRange()))), /*#__PURE__*/React.createElement("div", {
    className: "border-b border-e border-s border-solid border-gray-gainsboro px-3 py-4 rounded-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--distance-outline-rounded",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-xs font-bold"
  }, tShort("price_offer/success_inspection_location_title", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text text-sm font-semibold"
  }, renderAreaName())))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RatingComponent, {
    hideCta: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed bottom-0 w-full left-0 px-4 py-6 md:relative md:p-0 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col gap-4 md:flex-row-reverse md:gap-3 md:justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("transition-colors duration-200 ease-in md:w-full", "w-full p-3 bg-primary text-white rounded text-center font-bold border-none outline-none text-base md:max-w-[200px] cursor-pointer hover:bg-primary-120 transition-colors duration-200 ease-in md:max-w-full", "disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none"),
    onClick: function onClick() {
      navigateTo("/");
    }
  }, tShort("price_offer/goToHome", {
    ns: "web_sell_trade"
  })))))));
};
export default PriceOfferInspectionSuccessPage;